/**
 * Username — CLIENT-SIDE FORMAT FEEDBACK ONLY.
 *
 * Division of responsibility (see Identity module on the server):
 *  - Uniqueness is enforced on the BACKEND (source of truth).
 *  - This file mirrors the length and character rules so inline errors are instant. The server
 *    always re-validates on submit; if this mirror is ever out of step, the only cost is UX, never
 *    a bad write.
 *
 * Keep these values in sync with UsernameConstants on the server
 * (customerportalweb/src/Modules/Identity/Identity.Application/Constants/UsernameConstants.cs).
 */

/** Max length. Mirrors UsernameConstants.MaxLength (format feedback only). */
export const MAX_USERNAME_LENGTH = 100;

/** Min length. Mirrors UsernameConstants.MinLength — required whenever the field is submitted. */
export const MIN_USERNAME_LENGTH = 1;

/** Allowed characters. Mirrors UsernameConstants.Pattern (letters, digits, dot, underscore, hyphen). */
export const USERNAME_PATTERN = /^[a-zA-Z0-9._-]+$/;

/** Shown when a username breaks USERNAME_PATTERN — same wording as the Team page's Add/Edit User form. */
export const USERNAME_PATTERN_MESSAGE = 'Invalid characters in username.';
